export const DEFAULT_AVAILABLE_COMPANY_RESULT_COLUMNS = [
    'symbol',
    'price',
    'beta',
    'volAvg',
    'mktCap',
    'lastDiv',
    'companyName',
    'cik',
    'isin',
    'cusip',
    'exchange',
    'industry',
    'website',
    'description',
    'ceo',
    'sector',
    'country',
    'fullTimeEmployees',
    'phone',
    'address',
    'city',
    'state',
    'zip',
    'ipoDate',
] as const;

export const DEFAULT_COMPANY_RESULT_COLUMNS = ['fullTimeEmployees', 'industry', 'sector', 'city'] as const;
